<template>
  <div class="show-tickets">
    <div @click="setStep(3)" class="show-ticket-text">
      <div>Total:</div>
      <div>R$ {{ (total + serviceFee).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
      <div style="margin-left: 10px; text-transform: capitalize">{{ getTicketsTypes }}</div>
      <i v-if="step > 3" class="fas fa-angle-down"></i>
    </div>
    <form v-if="step === 3" @submit.prevent class="form" style="margin-top: 5px; align-items: flex-start">
      <div v-for="(t, i) in tickets" :key="t.id" class="show-ticket" :class="{ 'unavailable' : disableOptions(t) }">
        <div style="display: flex; align-items: center; border: none">
          <div style="text-transform: capitalize">{{ t.ticketType }}</div>
          <div v-if="disableOptions(t) && t.ticketType.toUpperCase().startsWith('MEIA')" style="text-transform: capitalize">ESGOTADO*</div>
          <div v-else-if="disableOptions(t)" style="text-transform: capitalize">ESGOTADO*</div>
          <div v-else>R$ {{ t.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
          <button @click="remove(t, i)" type="button"><i class="fas fa-minus"></i></button>
          <div>{{ t.buy }}</div>
          <button @click="add(t, i)" type="button"><i class="fas fa-plus"></i></button>
        </div>
      </div>
      <div style="
        margin: 10px 0 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      ">
        <div style="font-size: 0.7em" v-if="tickets.find(x => x.ticketType.toUpperCase().startsWith('MEIA') && disableOptions(x))">*O número de ingressos meia-entrada vendidos para esse espetáculo já atingiu a cota de 40% do total de ingressos disponíveis para venda ao público em geral, conforme Decreto Federal nº 8.537 e Leis Federais n° 12.933 e n° 12.852.</div>
        <div class="stage-text">Taxa de serviço: R$ {{ serviceFee.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
      </div>
    </form>
    <div v-if="step === 3 && (!show.online ? this.prices[0].sold < this.prices[0].businessCapacity : true)" class="show-ticket-total">
      <button @click="confirm" type="button" class="button-next"><span>Continuar</span><i class="fas fa-angle-right"></i></button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { reserveWithoutStage } from '../api/ticket'
import logger from '../../logger'

export default {
  name: 'showTicketNoStage',
  props: ['step', 'setStep', 'show', 'withoutStage', 'showDate', 'payment', 'prices', 'maxTicketUser', 'ticketsReserved', 'finishNoStage', 'preview'],
  data () {
    return {
      loading: false,
      tickets: []
    }
  },
  computed: {
    ...mapState(['user']),
    total () {
      return this.tickets.map(x => x.price * x.buy).reduce((acc, cur) => acc + cur, 0)
    },
    totalSold () {
      return this.tickets.reduce((acc, cur) => acc + cur.buy, 0) + this.prices.map(x => x.amountsold).reduce((acc, cur) => acc + cur, 0)
    },
    serviceFee () {
      return this.total * (this.payment ? this.payment.commission / 100 : 1)
    },
    getTicketsTypes () {
      if (this.tickets.length === 0) {
        return null
      } else {
        const types = this.tickets.reduce((accumulated, current) => {
          const found = accumulated.find(x => current.ticketType && x.type === current.ticketType)
          if (found) {
            found.count += current.buy
          } else {
            if (current.buy) accumulated.push({ type: current.ticketType, count: current.buy })
          }
          return accumulated
        }, [])

        if (types) {
          let aux = ''
          types.forEach((x, i) => {
            aux += x.count + ' ' + x.type + ', '
          })
          aux = aux ? '(' + aux.substring(0, aux.length - 2) + ')' : null
          return aux
        } else {
          return null
        }
      }
    }
  },
  watch: {
    showDate (value) {
      if (!this.withoutStage && !this.show.online) return false
      this.tickets = JSON.parse(JSON.stringify(this.prices))
      this.tickets.forEach(x => { x.buy = 0 })
    }
  },
  methods: {
    // validates ticket type and if has available tickets
    disableOptions (t) {
      // console.log(t, Number(t.businessCapacity - t.buy) <= Number(t.buy))
      if (this.totalSold === t.businessCapacity) return true
      if (this.prices[0].sold >= this.prices[0].businessCapacity) return true
      if (Number(t.businessCapacity - t.sold) <= Number(t.buy)) return true
      if (t.ticketType.toUpperCase().startsWith('MEIA') && Number(t.available) === 0) return true
      if (t.ticketType.toUpperCase().startsWith('MEIA') && Number(t.available) <= Number(t.buy)) return true
    },
    add (x, i) {
      // Is not authenticated
      if (!this.user) {
        this.$store.commit('showLogin', true)
        return false
      }

      if (this.disableOptions(x)) return false
      // Check tickets available
      if (x.ticketType.toUpperCase().startsWith('MEIA') && Number(x.available) <= x.buy) return false
      const total = this.tickets.map(x => x.buy).reduce((acc, cur) => acc + cur, 0)
      if (total === Number(this.maxTicketUser)) return false
      x.buy++
      this.$set(this.tickets, i, x)
    },
    remove (x, i) {
      if (x.buy === 0) return false
      x.buy--
      this.$set(this.tickets, i, x)
    },
    async confirm () {
      if (this.loading) {
        return false
      }
      this.loading = true
      try {
        const total = this.tickets.map(x => x.buy).reduce((acc, cur) => acc + cur, 0)
        if (total === 0) {
          this.$message.info('Selecione pelo menos 1 ingresso para poder continuar.', { duration: 3000 })
          this.loading = false
          return false
        }

        if (this.preview) {
          const tickets = []
          this.tickets.forEach(x => {
            for (let i = 0; i < x.buy; i++) {
              tickets.push({
                id: null,
                section: 1,
                seat: x,
                created: new Date(),
                showPrice: x.id
              })
            }
          })
          this.finishNoStage(tickets, new Date(), this.total + this.serviceFee)
          this.loading = false
        } else {
          const data = await reserveWithoutStage(this.showDate, this.tickets.map(x => ({ id: x.id, buy: x.buy })))
          if (!data) {
            this.loading = false
            return false
          }
          this.finishNoStage(data.tickets, data.now, this.total + this.serviceFee)
          this.loading = false
        }
      } catch (error) {
        this.loading = false
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          alert('Número de ingressos indisponíveis')
        } else {
          logger.error(error, this)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.stage-text {
  display: flex;
  align-items: center;
  width: 100%;
  color: #333;
  font-size: 1em;
  padding-top: 10px;
  font-weight: 300;
  width: 100%;
}

.show-tickets {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #d5d5d5;
  .show-ticket-text {
    display: flex;
    align-items: center;
    width: 100%;
    color: #333;
    font-size: 1em;
    font-weight: 300;
    div:nth-child(2) {
      color: $primary-color;
      font-size: 1.1em;
      font-weight: 500;
      margin-left: 10px;
    }
    i {
      flex: 1;
      text-align: right;
      cursor: pointer;
      font-size: 1.6em;
      color: #999;
    }
  }

  form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 5px 0;
  }

  .show-ticket {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 8px 0;
    div:nth-child(1) {
      border-radius: 5px 0 0 5px;
      border: 1px solid $primary-color;
      color: $primary-color;
      font-weight: 500;
      padding: 8px 7px;
      flex-grow: 1;
    }
    div:nth-child(2) {
      align-self: stretch;
      display: flex;
      align-items: center;
      border-radius: 0 5px 5px 0;
      border: 1px solid $primary-color;
      background: $primary-color;
      background: linear-gradient(to bottom right, $primary-color, $secondary-color);
      color: #fff;
      font-weight: 500;
      padding: 8px 7px;
      flex-shrink: 0;
      min-width: 100px;
      margin-right: 5px;
    }
    div:nth-child(4) {
      flex-shrink: 0;
      width: 20px;
      text-align: center;
      color: $primary-color;
    }
    button {
      flex-shrink: 0;
      border: none;
      background: $primary-color;
      background: linear-gradient(to bottom right, $primary-color, $secondary-color);
      width: 25px;
      height: 25px;
      border-radius: 50%;
      color: #fff;
      font-size: 1em;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 5px;
      cursor: pointer;
      &:focus {
        outline: none;
      }
    }
    .hint {
      width: 100%;
    }
    &.unavailable {
      div:nth-child(1) {
        border: 1px solid #999;
        color: #999;
      }
      div:nth-child(2) {
        border: 1px solid #999;
        background: #999;
      }
      div:nth-child(4) {
        color: #999;
      }
      button {
        background: #999;
      }
    }
  }
  .show-ticket-total {
    width: 100%;
    margin-top: 10px;
  }
}

@media screen and (min-width: $desktop-width) {

  .show-ticket {
    width: 45% !important;
  }

}
</style>
